import { toLocalCurrency, toLocalNumber, type GraphItem, type ProductType, type SkuType } from "@client/api-services/client";
import { useTranslation } from "react-i18next";
import { useUrlGenerator } from "~/apis/image-path";
import { useBrowserLocale } from "~/apis/utils";

export function TopupCard({ s, p, catalogItem }: { s: SkuType, p: ProductType, catalogItem: GraphItem }) {
	const { getCountryImageUrl, getOperatorImageUrl } = useUrlGenerator();
	const locale = useBrowserLocale();
	const { t } = useTranslation();
	return <>
		<div className="flex gap-2">
			<img className="w-8 rounded-lg" src={getCountryImageUrl(p.countryCode, "4x3")} />
			<img className="w-8 rounded-lg bg-white object-contain" src={getOperatorImageUrl(catalogItem.imageName)} />
			<div className="ml-auto text-right font-semibold flex gap-1 items-baseline">
				<span>{p.productName}</span>
			</div>
		</div>
		<div className="my-3"></div>
		<div className="flex items-baseline justify-between text-slate-700 gap-2">
			<div>
				<span className="text-2xl font-bold">{toLocalNumber(locale, s.localFaceValue.amount)}</span>
				<span>{s.localFaceValue.currencyCode}</span>
			</div>
			<span className="ml-auto text-xl font-semibold">
				{toLocalCurrency(locale, s.faceValue.amount, s.faceValue.currencyCode)}
			</span>
		</div>
		<hr className="border-t border-dashed border-t-slate-700/50 my-3" />
		<div className="text-right">
			<button className="btn-dark-sm" type="submit" name="skuId" value={s.skuId}>{t("skus.add_to_cart")}</button>
		</div>
	</>
}